<template>
<div class="search_bar">
  <form v-on:submit.prevent>
    <span class="icon_location"></span>
    <autocomplete class="adresse" :input-attrs="{ placeholder: $t('message[\'Commune ou département ou région\']') }" :value="$store.state.localisation.filter" :items="results" :get-label="getLabel" :component-item='communeTemplate' :auto-select-one-item="true" @update-items="search" @item-selected="communeSelected"/>
  </form>
</div>
</template>

<script>
// https://github.com/paliari/v-autocomplete
import Autocomplete from 'v-autocomplete'
import 'v-autocomplete/dist/v-autocomplete.css'
import axios from 'axios'
import CommuneTemplate from './SearchCommuneTemplate.vue'

export default {
  name: 'SearchCommune',
  components: {
    Autocomplete
  },

  i18n: {
    messages: {
      en: {
        message: {
          'Commune ou département ou région': 'City / Departement / Region'
        }
      },
      fr: {
        message: {
          'Commune ou département ou région': 'Commune ou département ou région'
        }
      }
    }
  },

  data() {
    return {
      selected: null,
      results: [],
      communeTemplate: CommuneTemplate
    }
  },

  methods: {
    getLabel(item) {
      return item ? item.label : ''
    },
    search(text) {
      axios.get('/api/v1/localisation', {
        params: {
          nom: text,
          limit: 20
        }
      })
        .then((response) => {
          this.results = response.data.data
          for (let i = this.results.length - 1; i >= 0; i--) {
            const result = this.results[i]

            // Si on est pas une commune (dans le cas de Saint Barthelemy on garde uniquement la commune en 977)
            if (result.type !== 'COM') {
              // On cherche un élément dupliqué (même nom et même emprise)
              const duplicate = this.results.find(a =>
                a.nom === result.nom &&
                a.maxlat === result.maxlat &&
                a.minlat === result.minlat &&
                a.maxlon === result.maxlon &&
                a.minlon === result.minlon &&
                a.id !== result.id
              )

              // S'il existe une valeur dupliquée alors on enlève l'occurence actuelle
              if (duplicate) {
                this.results.splice(i, 1)
              }
            }
          }
        })
        .catch(function(error) {
          console.error('communes', error)
        })
    },
    communeSelected(commune) {
      // On agit directement
      this.$store.state.localisation.filter = commune
      this.go()
    },

    go() {
      if (this.$store.state.localisation.filter) {
        // On supprime la recherche d'adresse
        this.$store.state.adresse.filter = null

        let s = this.$store.state.localisation.filter
        let lon = (Number(s.maxlon) + Number(s.minlon)) / 2.0
        let lat = (Number(s.maxlat) + Number(s.minlat)) / 2.0
        this.$emit('lonlat', {
          lon,
          lat,
          commune: s
        })
        this.$emit('changeLocalisation')
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.commune_search_bar .v-autocomplete-list {
  width: 70%;
  z-index: 100;
  max-height: 200px;
  overflow-y: scroll;
}

.v-autocomplete-list-item {
  cursor: pointer;
  background-color: #fff;
  color: #000;
  padding: 10px;
  border-bottom: 1px solid #a8a8a8;
}

.commune_search_bar.search_bar .v-autocomplete-input {
  border: 1px solid #a8a8a8;
  padding: 6px 11px;
  font-size: 0.9em;
}
.commune_search_bar.search_bar.disabled .v-autocomplete-input:focus {
  background-color: #fff;
  color: #000;
  cursor: text;
  border: 1px solid #a8a8a8;
  padding: 6px 11px;
}
.commune_search_bar.search_bar.disabled .v-autocomplete-input {
  background-color: rgb(235, 235, 228);
  color: rgb(84, 84, 84);
  cursor: default;
  border: none;
  padding: 7px 12px;
}

.commune_search_bar.search_bar .v-autocomplete-list-item {
  font-size: 0.9em;
}
</style>
